module.exports = __webpack_public_path__ + "static/media/A TRIAL 2-if-correct-kopi.4b8ad031.mp3";